import React, { useState } from 'react';
import { Element } from 'react-scroll';
import ModalBenefits from './ModalBenefits';
import ModalCoverage from './ModalCoverage';
import ModalNotCoverage from './ModalNotCoverage';
import ModalRequirements from './ModalRequirements';

export default function InfoNavbar() {
  const [openCoverage, setOpenCoverage] = useState(false);
  const [openNotCoverage, setOpenNotCoverage] = useState(false);
  const [openBenefits, setOpenBenefits] = useState(false);
  const [openRequirements, setOpenRequirements] = useState(false);
  const toggleCoverage = (state: boolean) => (_: any) => setOpenCoverage(state);
  const toggleNotCoverage = (state: boolean) => (_: any) => setOpenNotCoverage(state);
  const toggleBenefits = (state: boolean) => (_: any) => setOpenBenefits(state);
  const toggleRequirements = (state: boolean) => (_: any) => setOpenRequirements(state);

  return (
    <>
      <div className="container-fluid mt50 coverage-and-benefits">
        <div className="container pd-sm-0">
          <Element name="coverage-and-benefits" className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-7 col-lg-6 d-flex">
              <img
                className="margin-top-0_5"
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_salud-filled.svg"
                alt="Logo Salud Complementario"
                width="38.57"
                height="38.57"
              />
              <h4 className="padding-1 px-20">Coberturas y beneficios</h4>
            </div>
          </Element>
          <div className="row d-flex-wrap justify-content-center">
            <div className="col-12 col-sm-8 col-md-7 col-lg-6">
              <div className="w-100 button-toggle-modal justify-content-center align-content-center" onClick={toggleCoverage(true)}>
                <p className="px-16">Qué cubre</p>
                <span className="px-14 w-100">Gastos generales, gastos hospitalarios, Maternidad, salud mental, otros...</span>
              </div>
              <div className="w-100 button-toggle-modal justify-content-center align-content-center" onClick={toggleNotCoverage(true)}>
                <p className="px-16">Qué no cubre</p>
                <span className="px-14 w-100">Preexistencias, embarazo antes de contratar el seguro, guerras, epidemias, otros...</span>
              </div>
              <div className="w-100 button-toggle-modal justify-content-center align-content-center" onClick={toggleBenefits(true)}>
                <p className="px-16">Beneficios</p>
                <span className="px-14 w-100">Protección en el extranjero, cristales y marcos, lentes, prótesis, cirugía Lasik, otros...</span>
              </div>
              <div className="w-100 button-toggle-modal justify-content-center align-content-center" onClick={toggleRequirements(true)}>
                <p className="px-16">Requisitos</p>
                <span className="px-14 w-100">Ser mayor de edad, contar con Isapre o Fonasa, otros...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalCoverage open={openCoverage} toggle={toggleCoverage}/>
      <ModalNotCoverage open={openNotCoverage} toggle={toggleNotCoverage}/>
      <ModalBenefits open={openBenefits} toggle={toggleBenefits}/>
      <ModalRequirements open={openRequirements} toggle={toggleRequirements}/>
    </>
  );
}
